import type { StudentPortfolioActivityShallowResource } from "api/generated";

export const shallowActivityFromDto = (
  resource: StudentPortfolioActivityShallowResource,
) => ({
  id: resource.id,
  title: resource.title,
  meta: {
    canUpdate: resource.meta.can_update,
  },
});
